import React, { useEffect } from "react";
import { PageStructure } from "../../pages";
import { AddActionButton,CalendarView, Calendar as CalendarComponent} from "../../components";


const Calendar = (props) => {
  return (
    <PageStructure>

      <AddActionButton/>
      <CalendarView />
      {/* <hr/> */}
      {/* <CalendarComponent /> */}
    </PageStructure>
  );
};

export default Calendar;
